import { type } from "arktype";
import { Item, type ItemName } from "~/types";

export const items: Record<ItemName, Item> = {};
document.getElementById("loading-status")!.innerText = "Preparing load...";

export function fetchItemBundle(bundleId: string) {
	const xhr = new XMLHttpRequest();
	xhr.onprogress = (e) => {
		const totalBytes = e.total;
		const loadedBytes = e.loaded;
		document.getElementById("loading-text")!.innerHTML = `Loading... ${Math.round((loadedBytes / totalBytes) * 100)}%`;
		document.getElementById("loading-status")!.innerHTML =
			`Loaded data (${Math.ceil(loadedBytes / 1e3)} kB/${Math.ceil(totalBytes / 1e3)} kB)...`;
		document.getElementById("loading-progress")!.style.width = `${(loadedBytes / totalBytes) * 100}%`;
	};
	xhr.onload = () => {
		document.getElementById("loading-text")!.innerHTML = "Nearly there...";
		document.getElementById("loading-status")!.innerHTML = "Decoding...";

		setTimeout(() => {
			const decoded = JSON.parse(xhr.response) as Record<string, unknown>;

			Object.keys(decoded).forEach((e) => {
				if (e.startsWith("@")) delete decoded[e];
			});
			const parsed = type({ "[string]": Item })(decoded);

			if (parsed instanceof type.errors) {
				console.error(parsed.summary);
				throw new Error("frick");
			}

			Object.assign(items, parsed);
			itemsMap = new Map(Object.entries(items) as Array<[ItemName, Item]>);

			if (resolveOnLoad) {
				resolveOnLoad(null);
				console.log(`Loaded ${Object.keys(decoded).length} items!`);
			} else {
				document.getElementById("loading-text")!.innerHTML = "An error occurred";
				document.getElementById("loading-status")!.innerHTML = "Try reloading the page, or try again another time...";
				return;
			}
		}, 1);
	};
	xhr.responseType = "";
	xhr.open("GET", `/data/bundles/${bundleId}.json`);
	xhr.send();
}

export let itemsMap: Map<ItemName, Item>;

let resolveOnLoad: ((t: null) => void) | null = null;
export function onload() {
	return new Promise((res) => {
		if (itemsMap) {
			res(null);
		} else {
			resolveOnLoad = res;
		}
	});
}
